import { BuildingOrg } from 'shared/models';

export const propertyNameLabelKeys: Record<keyof BuildingOrg['properties'], string> = {
    isContractor:      'ORGS.LABEL.CONTRACTOR',
    isCallMonitor:     'ORGS.LABEL.CALL_MONITOR',
    isOwner:           'ORGS.LABEL.OWNER',
    isPropertyManager: 'ORGS.LABEL.MANAGER',
    isDistributor:     'ORGS.LABEL.DISTRIBUTOR',
    isAdvertiser:      'ORGS.LABEL.ADVERTISER',
};
